<template>
  <f7-page name="upcoming" class="news">
    <f7-navbar title="News" back-link="Back">
      <f7-nav-right>
        <f7-link  href="/" class="menu-icon"><i class="az-icon-home-house-interface-ui-website"></i></f7-link>
      </f7-nav-right>
    </f7-navbar>


      <f7-row>
        <div class="col-40 col-sm-0">
          <div class="left-az-logo">
            <img src="../assets/images/left-logo.png" alt="" />
          </div>
        </div>
        <div class="col-60 col-sm-100">
              <f7-block-title>News</f7-block-title>

    <div class="upcoming-box feedback-list-item" v-if="news.data && news.data.length">
      <div class="card demo-card-header-pic article-post" v-for="item in news.data" :key="item.id">
        <div :style="'background-size: cover; height: 40vw; color: #FFF; font-weight: bold; background-image:url('+ $root.siteURL + item.photo.replace('public', 'storage') + ')'" class="card-header align-items-flex-end article-img">{{ item.title }}</div>
        <div class="card-content card-content-padding">
          <p class="date">{{ item.created_at }} - <strong>{{ item.event.name }}</strong></p>
          <p v-html="item.summary"></p>
        </div>
        <div class="card-footer">
          <a href="#" class="link button button-fill" @click.prevent="showDetails(item)">Read more</a>
        </div>
      </div>
      <p v-if="news.total && news.total > 1 && news.next_page_url  != null">
        <a href="#" class="button button-fill block" @click.prevent="getNews(news.next_page_url)">Load More Articles</a>
      </p>
    </div>

        </div>
      </f7-row>




  </f7-page>
</template>
<script>
export default {
    data() {
      return {
        news: []
      }
    },
    methods: {
      getNews: function(url) {
        this.$f7.preloader.show()
        this.$http.get( url ? url : this.$root.apiBaseURL + 'news' )
        .then( (res) => {
          var old_news = this.news.data || []
          this.news = res.data.news
          this.news.data = old_news.concat(this.news.data)
          this.$f7.preloader.hide()
        })
        .catch( (err) => {
          console.log(err)
          this.$f7.preloader.hide()
        })
      },
      showDetails: function(item) {
        sessionStorage.setItem('currentNews', JSON.stringify(item))
        this.$f7.view.current.router.navigate('/news-details/')
      }
    },
    mounted: function() {
      this.getNews()
    }
}
</script>
<style scoped>
  .menu-icon i::before {
    color: #870047;
    font-size: 35px;
  }
</style>
